export const LEGEND_SECTIONS = [
  {
    id: "soilMoisture",
    show: "showSoilMoisture",
    sectionKey: null,
    type: "gradient",
    ticks: [">0", 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
    gradient: `linear-gradient(to right,
      rgba(210,180,140,0) 0%, rgb(210,180,140) 10%, rgb(160,190,170) 20%,
      rgb(100,200,200) 30%, rgb(80,180,220) 40%, rgb(50,150,240) 50%,
      rgb(30,120,230) 60%, rgb(20,100,200) 70%, rgb(15,80,180) 80%,
      rgb(10,60,150) 90%, rgb(5,40,120) 100%)`,
  },
  {
    id: "windSpeed",
    show: "showWindSpeedData",
    sectionKey: null,
    type: "gradient",
    ticks: [0, 7, 18, 36, 54, 72, 90, 108, 126, 144, "+160"],
    gradient: `linear-gradient(to right,
      rgba(255,255,255,0.8) 0%, rgba(186,85,211,0.6) 10%, rgb(75,0,130) 20%,
      rgb(255,140,0) 30%, rgb(255,165,0) 40%, rgb(255,215,0) 50%,
      rgb(255,69,0) 60%, rgb(255,0,0) 70%, rgb(139,0,0) 80%,
      rgb(255,20,147) 90%, rgb(139,0,255) 100%)`,
  },
  {
    id: "cloudCover",
    show: "showCloudCover",
    sectionKey: null,
    type: "gradient",
    ticks: [5, 20, 40, 60, 80, 100],
    gradient: `linear-gradient(to right,
      rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 20%,
      rgba(255,255,255,0.4) 40%, rgba(255,255,255,0.6) 60%,
      rgba(255,255,255,0.8) 80%, rgba(255,255,255,1.0) 100%)`,
  },
  {
    id: "precipitations",
    show: "showPrecipitations",
    sectionKey: null,
    type: "gradient",
    ticks: [0.25, 2, 5, 10, 20, 40, 70, 100, 500, 1000],
    gradient: `linear-gradient(to right,
      rgba(253,198,206,0.7) 0%, rgba(241,15,91,0.7) 10%, rgba(186,85,211,0.7) 20%,
      rgb(40,207,219) 30%, rgb(15,126,190) 40%, rgb(172,6,172) 50%,
      rgb(133,6,165) 60%, rgba(195,0,255,0.45) 70%, rgb(18,101,150) 80%,
      rgb(16,74,184) 100%)`,
  },
  {
    id: "hourlyPrecipitations",
    show: "showHourlyPrecipitations",
    sectionKey: null,
    type: "gradient",
    ticks: [0.25, 2, 5, 10, 20, 40, 70, 100, 500, 1000],
    gradient: `linear-gradient(to right,
      rgba(224,243,255,0.7) 0%, rgba(168,221,255,0.7) 10%, rgba(100,191,255,0.7) 20%,
      rgba(51,153,255,0.7) 30%, rgba(0,102,204,0.7) 40%, rgba(0,51,153,0.7) 50%,
      rgba(102,0,153,0.7) 60%, rgba(153,0,153,0.7) 70%, rgba(204,0,102,0.7) 80%,
      rgba(255,0,0,0.7) 100%)`,
  },
  {
    id: "temperature",
    show: "showTemperature",
    sectionKey: null,
    type: "gradient",
    ticks: [-20, -10, 0, 10, 20, 25, 30, 40, 45, 50],
    gradient: `linear-gradient(to right,
      rgba(0,0,139,0.7) 0%, rgba(9,13,238,0.7) 10%, rgba(7,152,248,0.7) 20%,
      rgba(13,225,233,0.7) 30%, rgba(173,216,230,0.7) 40%, rgba(255,215,0,0.7) 50%,
      rgba(245,141,23,0.93) 60%, rgba(252,115,2,0.94) 70%, rgba(255,69,0,0.7) 80%,
      rgba(128,0,0,0.7) 100%)`,
  },
  {
    id: "relativeHumidity",
    show: "showRelativeHumidity",
    sectionKey: null,
    type: "gradient",
    ticks: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
    gradient: `linear-gradient(to right,
      rgba(255,255,224,0.7) 0%, rgba(255,239,163,0.7) 10%, rgba(250,211,55,0.7) 20%,
      rgba(152,251,152,0.7) 30%, rgba(99,233,99,0.7) 40%, rgba(0,255,128,0.93) 50%,
      rgba(0,255,255,0.7) 60%, rgba(118,179,230,0.7) 70%, rgba(38,112,248,0.7) 80%,
      rgba(34,34,247,0.7) 90%, rgba(0,0,139,0.7) 100%)`,
  },
  {
    id: "pressure",
    show: "showMeanSeaLevelPressure",
    sectionKey: null,
    type: "gradient",
    ticks: ["90K", "100K", "102K", "105K", "107K", "110K"],
    gradient: `linear-gradient(to right,
      rgba(145,130,255,0.7) 0%, rgba(245,18,75,0.7) 20%, rgba(71,41,240,0.7) 40%,
      rgba(22,2,87,0.7) 60%, rgba(168,58,73,0.7) 80%, rgba(139,0,0,0.7) 100%)`,
  },
  {
    id: "windGust",
    show: "showWindGust",
    sectionKey: null,
    type: "gradient",
    ticks: [0, 18, 36, 54, 72, 90, "+100"],
    gradient: `linear-gradient(to right,
      rgba(173,216,230,0.7) 0%, rgba(144,238,144,0.7) 10%, rgba(255,223,0,0.7) 20%,
      rgba(255,165,0,0.7) 40%, rgba(255,69,0,0.7) 60%, rgba(255,0,0,0.7) 80%,
      rgba(139,0,0,0.7) 100%)`,
  },
  {
    id: "dem",
    show: "showDem",
    sectionKey: null,
    type: "gradient",
    ticks: ["<0", 0, 100, 250, 500, 800, 1500, "+1500"],
    gradient: `linear-gradient(to right,
      #140F7C 0%, #2A7FFF 14%, #00E5FF 29%, #58FF6C 43%,
      #FFEA32 57%, #FF8F32 71%, #FF2E00 86%, #FF2E00 100%)`,
  },

  // ─── Limites administratives ──────────────────────────────────────
  {
    id: "regions",
    show: "showRegions",
    sectionKey: "adminBoundaries",
    type: "line",
    color: "blue",
    hasPopup: true,
  },
  {
    id: "departements",
    show: "showDepartements",
    sectionKey: "adminBoundaries",
    type: "line",
    color: "rgba(28,252,252,1)",
    hasPopup: true,
  },

  {
    id: "lai",
    show: "showLai",
    sectionKey: "terrainLayers",
    type: "gradient",
    ticks: [">0", 1, 2, "3+"],
    gradient: `linear-gradient(to right, #A1D9C1 0%, #73C1AB 33%, rgb(8,82,68) 100%)`,
  },
  {
    id: "deadFuel",
    show: "showDeadFuel",
    sectionKey: "terrainLayers",
    type: "gradient",
    ticks: [">0", 10, 20, 30, "+30"],
    gradient: `linear-gradient(to right,
      #800026 0%, #bd0026 4%, #e31a1c 8%, #fc4e2a 12%, #fd8d3c 16%,
      #feb24c 20%, #fed976 24%, #ffffb2 30%, #d9f0a3 36%, #addd8e 44%,
      #78c679 52%, #41ab5d 60%, #238443 75%, #004529 100%)`,
  },
  {
    id: "vegHeight",
    show: "showVegHeight",
    sectionKey: "terrainLayers",
    type: "gradient",
    ticks: [">0", 3, 10, 20, "20+"],
    gradient: `linear-gradient(to right, #D5B5E5 0%, #A07DC3 33%, rgb(114,69,160) 66%, rgb(53,36,109) 100%)`,
  },
  {
    id: "biomass",
    show: "showBiomass",
    sectionKey: "terrainLayers",
    type: "gradient",
    ticks: [">0", 8, 14, 20, "20+"],
    gradient: `linear-gradient(to right, #F5B46F 0%, #DB804C 33%, rgb(235,98,19) 66%, rgb(119,53,29) 100%)`,
  },
  {
    id: "totalFuelLoad",
    show: "showTotalFuelLoad",
    sectionKey: "terrainLayers",
    type: "gradient",
    ticks: [">0", 1, 2, 3, 4, "4+"],
    gradient: `linear-gradient(to right, #FFEAEA 0%, #FFB3B3 25%, #FF6666 50%, #CC1F1F 75%, #800000 100%)`,
  },
  {
    id: "bareSoil",
    show: "showBareSoil",
    sectionKey: "terrainLayers",
    type: "color",
    color: "#D2B48C",
    hasPopup: true,
  },
  {
    id: "broadleaf",
    show: "showBroadleaf",
    sectionKey: "terrainLayers",
    type: "color",
    color: "#65920b",
    hasPopup: true,
  },
  {
    id: "mixedForest",
    show: "showMixedForest",
    sectionKey: "terrainLayers",
    type: "color",
    color: "#0ceb31",
    hasPopup: true,
  },
  {
    id: "coniferous",
    show: "showConiferous",
    sectionKey: "terrainLayers",
    type: "color",
    color: "#76f5a4",
    hasPopup: true,
  },
  {
    id: "shrubland",
    show: "showShrubland",
    sectionKey: "terrainLayers",
    type: "color",
    color: "#d9d925",
    hasPopup: true,
  },
  {
    id: "cropland",
    show: "showCropland",
    sectionKey: "terrainLayers",
    type: "color",
    color: "#ebaf0a",
    hasPopup: true,
  },
  {
    id: "grassland",
    show: "showGrassland",
    sectionKey: "terrainLayers",
    type: "color",
    color: "#9ACD32",
    hasPopup: true,
  },
  {
    id: "oak",
    show: "showOak",
    sectionKey: "terrainLayers",
    type: "color",
    color: "#ffb3ee",
    hasPopup: true,
  },
  {
    id: "pine",
    show: "showPine",
    sectionKey: "terrainLayers",
    type: "color",
    color: "#b69af5",
    hasPopup: true,
  },
  {
    id: "water",
    show: "showWater",
    sectionKey: "waterResources",
    type: "icon",
    iconKey: "waterResourcesIcon",
    hasPopup: true,
  },
  {
    id: "artificielWater",
    show: "showArtificielWater",
    sectionKey: "waterResources",
    type: "icon",
    iconKey: "swimmingPoolsIcon",
    hasPopup: true,
  },
  {
    id: "dfci",
    show: "showDfci",
    sectionKey: "adminBoundaries",
    type: "line",
    color: "#0B03FF",
    dashed: true,
    hasPopup: true,
  },
  {
    id: "urban",
    show: "showUrban",
    sectionKey: "terrainLayers",
    type: "color",
    color: "#8a8686",
    hasPopup: true,
  },

  // ─── buildings in risk ───────────────────────────────────────────
  {
    id: "result1Buildings",
    show: "showResult1Buildings",
    sectionKey: "buildingsRisk",
    type: "icon",
    iconKey: "buildings_t1",
    iconSize: 22,
    hasPopup: true,
  },
  {
    id: "result2Buildings",
    show: "showResult2Buildings",
    sectionKey: "buildingsRisk",
    type: "icon",
    iconKey: "buildings_t2",
    iconSize: 22,
    hasPopup: true,
  },
  {
    id: "result3Buildings",
    show: "showResult3Buildings",
    sectionKey: "buildingsRisk",
    type: "icon",
    iconKey: "buildings_t3",
    iconSize: 22,
    hasPopup: true,
  },
  {
    id: "result4Buildings",
    show: "showResult4Buildings",
    sectionKey: "buildingsRisk",
    type: "icon",
    iconKey: "buildings_t4",
    iconSize: 22,
    hasPopup: true,
  },

  // ─── Points sensibles ─────────────────────────────────────────────
  {
    id: "electricalLinesAerial",
    show: "showElectricalLines",
    sectionKey: "sensitivePoints",
    type: "line",
    color: "#ff0000",
    hasPopup: true,
  },
  {
    id: "electricalStations",
    show: "showElectricalStations",
    sectionKey: "sensitivePoints",
    type: "color",
    color: "red",
    hasPopup: true,
  },
  {
    id: "electricalTransformers",
    show: "showElectricalStations",
    sectionKey: "sensitivePoints",
    type: "point",
    color: "orange",
    hasPopup: true,
  },
  {
    id: "gazLines",
    show: "showGazLines",
    sectionKey: "sensitivePoints",
    type: "line",
    color: "#FFD700",
    hasPopup: true,
  },
  {
    id: "gazRefuelingStations",
    show: "showGazRefuelingStations",
    sectionKey: "sensitivePoints",
    type: "point",
    color: "#FFD700",
    hasPopup: true,
  },

  // ─── roads ───────────────────────────────────────────────────────
  {
    id: "majorRoads",
    show: "showMajorRoads",
    sectionKey: "roads",
    type: "road",
    thickness: 5,
    color: "black",
    hasPopup: true,
  },
  {
    id: "secondaryRoads",
    show: "showMajorRoads",
    sectionKey: "roads",
    type: "road",
    thickness: 4,
    color: "black",
    minZoom: 10,
    hasPopup: true,
  },
  {
    id: "residentialRoads",
    show: "showMajorRoads",
    sectionKey: "roads",
    type: "road",
    thickness: 3,
    color: "black",
    minZoom: 13,
    hasPopup: true,
  },
  {
    id: "accessPaths",
    show: "showMajorRoads",
    sectionKey: "roads",
    type: "road",
    thickness: 2,
    color: "black",
    minZoom: 13,
    hasPopup: true,
  },
  {
    id: "railways",
    show: "showRailways",
    sectionKey: "roads",
    type: "line",
    color: "#503B3B",
    hasPopup: true,
  },
  {
    id: "trainStations",
    show: "showRailways",
    sectionKey: "roads",
    type: "point",
    color: "#503B3B",
  },

  // ─── Security ────────────────────────────────────────────────────
  {
    id: "fireStations",
    show: "showFireStations",
    sectionKey: "safety",
    type: "icon",
    iconKey: "fireDepartementIcon",
    iconSize: 16,
    hasPopup: true,
  },
  // ─── active fires ────────────────────────────────────────────────
  {
    id: "activeFires",
    show: "showActiveFires",
    sectionKey: "activeFires",
    type: "icon",
    iconKey: "activeFire",
    iconSize: 22,
    hasPopup: true,
  },
  {
    id: "historicFiresArea",
    show: "showHistoricFires",
    sectionKey: null,
    type: "color",
    color: "rgba(255,0,0,0.55)",
    hasPopup: true,
  },
  {
    id: "historicFiresIcon",
    show: "showHistoricFires",
    sectionKey: null,
    type: "icon",
    iconKey: "historicFire",
    iconSize: 20,
    hasPopup: true,
  },
];